/**
 * Retrieves provider info from URL parameters.
 * Depending on the provider, the URL parameters may vary.
 * @returns Promise resolving to an object with the provider info
 */
export function getProviderInfo(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const providerInfo: Record<string, string> = {};

  for (const [key, value] of params.entries()) {
    providerInfo[key] = value;
  }

  return providerInfo;
}
